module.exports = __webpack_public_path__ + "img/pellets-banner-720w.1f66497.webp";